export default {
  titles: {
    alaCarte: {
      en: 'One-time purchase:',
    },
    perfume: {
      en: 'Full size:',
    },
    discount: {
      en: 'Member discount price:',
    },
    subscription: {
      en: `Subscription price:`,
    },
  },
  descriptions: {
    fragrance: {
      en: '30&#8209;day&nbsp;supply&nbsp;of&nbsp;fragrance',
    },
    fullSized: {
      en: 'Full-size product',
    },
    candle: {
      en: 'Full-sized scented candle, 40&#8209;hr&nbsp;burn&nbsp;time',
    },
    delivery: {
      en: 'Ships in 5 days. <span class="text-bold">{volume}</span>',
    },
  },
  outOfStock: {
    en: 'Out of stock',
  },
  upchargePrice: {
    en: 'Premium upcharge:',
  },
}
